import type { ReactElement, ReactNode } from 'react';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { Tooltip as ShadcnTooltip, TooltipProvider, TooltipTrigger } from '@/lib/shadcn/tooltip';

interface TooltipProps {
  content: ReactNode;
  children: ReactElement;
  side?: 'top' | 'bottom' | 'left' | 'right';
  delayDuration?: number;
}

export function Tooltip({ content, children, side = 'top', delayDuration = 300 }: TooltipProps) {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <ShadcnTooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        {/*
         * Using TooltipPrimitive.Content directly (not the shadcn wrapper) so we
         * can omit overflow-hidden — the shadcn wrapper hard-codes it and it clips
         * the arrow even when overridden via className.
         */}
        <TooltipPrimitive.Content
          side={side}
          sideOffset={8}
          className="z-50 rounded-md bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
        >
          {content}
          <TooltipPrimitive.Arrow className="fill-popover" />
        </TooltipPrimitive.Content>
      </ShadcnTooltip>
    </TooltipProvider>
  );
}
